import { useEffect, useRef } from 'react';

export function useFocusOnSubmittedCharge(submittedChargeId?: string) {
  const chargesRegionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (submittedChargeId) {
      chargesRegionRef.current?.focus();
    }
  }, [submittedChargeId]);

  return chargesRegionRef;
}
